import { hot } from 'react-hot-loader/root';
import React from 'react';

import AppRouter from './router/AppRouter';

const App = () => <AppRouter />;

export default hot(App);
